/* sleep-doctor-reviews.js — Swiper carousel, mobile only */

const SWIPER_JS  = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

function loadSwiper() {
  if (window.__sleepReviewsSwiperPromise) return window.__sleepReviewsSwiperPromise;

  window.__sleepReviewsSwiperPromise = new Promise((resolve) => {
    if (window.Swiper) { resolve(window.Swiper); return; }

    if (!document.querySelector('link[data-swiper-css]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = SWIPER_CSS;
      link.setAttribute('data-swiper-css', '');
      document.head.appendChild(link);
    }

    const script = document.createElement('script');
    script.src = SWIPER_JS;
    script.defer = true;
    script.onload = () => resolve(window.Swiper);
    document.head.appendChild(script);
  });

  return window.__sleepReviewsSwiperPromise;
}

function initCarousel(SwiperClass, carouselEl) {
  const mq = window.matchMedia('(max-width: 767px)');
  let swiper = null;

  /* Controls live as siblings inside the carousel-wrap, outside .swiper */
  const wrap = carouselEl.parentElement;
  const prevEl = wrap.querySelector('[data-prev]');
  const nextEl = wrap.querySelector('[data-next]');
  const paginationEl = wrap.querySelector('[data-pagination]');

  function create() {
    return new SwiperClass(carouselEl, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 0,
      loop: false,
      grabCursor: true,
      initialSlide:1,
      navigation: {
        prevEl,
        nextEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous review',
        nextSlideMessage: 'Next review',
        paginationBulletMessage: 'Go to review {{index}}',
      },
    });
  }

  function sync() {
    if (mq.matches && !swiper) {
      swiper = create();
    } else if (!mq.matches && swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
  }

  mq.addEventListener('change', sync);
  sync();

  return function cleanup() {
    mq.removeEventListener('change', sync);
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
  };
}

function initSection(sectionEl) {
  const carousels = sectionEl.querySelectorAll('[data-carousel]');
  if (!carousels.length) return null;

  const cleanupFns = [];

  loadSwiper().then((SwiperClass) => {
    carousels.forEach((el) => {
      cleanupFns.push(initCarousel(SwiperClass, el));
    });
  });

  return function cleanup() {
    cleanupFns.forEach((fn) => fn && fn());
    cleanupFns.length = 0;
  };
}

/* Track active instances for theme editor cleanup */
const registry = new WeakMap();

function findSection(target) {
  return target.querySelector('.sleep-reviews') || (target.classList.contains('sleep-reviews') ? target : null);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sleep-reviews').forEach((el) => {
    registry.set(el, initSection(el));
  });
});

document.addEventListener('shopify:section:load', (e) => {
  const sectionEl = findSection(e.target);
  if (!sectionEl) return;
  registry.set(sectionEl, initSection(sectionEl));
});

document.addEventListener('shopify:section:unload', (e) => {
  const sectionEl = findSection(e.target);
  if (!sectionEl) return;
  const cleanup = registry.get(sectionEl);
  if (cleanup) cleanup();
  registry.delete(sectionEl);
});
